import api from '@pray/shared/utils/api';

import type { SeedCampaignDetailResponse, SeedCampaignType } from './types';

const CAMPAIGNS_URL = '/web/studio/admin/seed-emails/campaigns';

export type GetSeedCampaignParams = {
  campaignType: SeedCampaignType;
  campaignId: string;
  artistId: string;
};

/**
 * One campaign as step 1 needs it: its slug, its sender, and every token and catalog its template
 * asks about.
 *
 * Three refusals the wizard tells apart by their stable code, not by their status: 404
 * `seed_run_campaign_not_found` for a campaign that is gone, 404 `seed_campaign_artist_mismatch`
 * for one that belongs to another artist, and 400 `seed_campaign_template_unreadable` for a
 * template the server's Liquid parser cannot read.
 */
export async function getSeedCampaign({ campaignType, campaignId, artistId }: GetSeedCampaignParams) {
  const res = await api.executeGetRequest<{ data: SeedCampaignDetailResponse }>(
    `${CAMPAIGNS_URL}/${campaignType}/${campaignId}`,
    { artist_id: artistId }
  );
  return res.data.data;
}
